// extracted by mini-css-extract-plugin
export default {"header":"index_header__baNVq","inputstyle":"index_inputstyle__YqfOJ"};